import React, { useState, useContext, useEffect, useCallback } from 'react';
import Loading from '../Loading';
import { Container, Row, Col } from 'react-bootstrap';
import { useLocation, useHistory } from "react-router-dom";
import { messagePost } from '../../api';
import { somethingWentWrongNotice, replyMessageNotice, userNotFound } from '../UI/Notifications';
import { UserContext } from 'context/User';
import TextInput from '../UI/TextInput';
import TextArea from '../UI/TextArea';
import { useForm } from 'react-hook-form';

const SendSpecificMessage = () => {
  const useQuery = () => new URLSearchParams(useLocation().search);
  const { setIsLoggedIn, setUser } = useContext(UserContext);
  const query = useQuery();
  const id = query.get("id");
  const [loading, setLoading] = useState(false);
  const history = useHistory();
  const { register, handleSubmit, errors } = useForm();

  const logout = () => {
    setIsLoggedIn(false);
    setUser({});
    history.push('/');
  }

  const handleDefaultStatusCodes = (status_code) => {
    if (status_code === 440 || status_code === 401) {
      logout()
    } else {
      somethingWentWrongNotice("Inbox");
    }
    setLoading(false);
  }

  const onSubmit = data => {
    setLoading(true);

    const body = {
      receiver: +id,
      ...data
    }

    if (!body.body) delete body.body;
    if (!body.subject) delete body.subject;

    messagePost(body)
      .then(() => {
        replyMessageNotice("Send Message");
        setLoading(false);
      })
      .catch(error => {
        if (error.response.status === 404) {
          userNotFound("Send Message");
          setLoading(false);
        } else {
          handleDefaultStatusCodes(error.response.status);
        }
      });
  }

  const cancelSendMessage = () => {
    history.goBack();
  }

  const handleEsc = useCallback((e) => {
    if(e.keyCode === 27) {
    history.goBack();
    }
  }, []);


  useEffect(() => {
    document.addEventListener("keydown", handleEsc, false);

    return () => {
      document.removeEventListener("keydown", handleEsc, false);
    };
  }, []);


  return (
    <section className="section-spaces">
      <form onSubmit={handleSubmit(onSubmit)}>
        <Container>
          <Row>
            <Col>
              <h3 className="mb-5 text-center">
                Send Message
              </h3>
            </Col>  
          </Row>
          <Row>
            <Col lg={{ span: 6, offset: 3 }}>
              <fieldset>
                <label htmlFor="subject">Subject</label>
                <TextInput 
                  name="subject" 
                  register={register({ required: true })}
                />
              </fieldset>
              {errors.subject && (
                <p className="warnMessage">This field is required</p>
              )}
              <fieldset>
                <label htmlFor="body">Message</label>
                <TextArea 
                  name="body" 
                  register={register()}
                />
              </fieldset>
            </Col>
          </Row>
          <Row className="mt-5">
            <Col className="text-right" lg={{ span: 6, offset: 3 }}>
              <span
                type="button"
                className="btnSizes transparentBtn border-0"
                onClick={cancelSendMessage}
              >
                Cancel
              </span>
              <button
                className='btnSizes filledBtn ml-5'
              >
                Send Message
              </button>
            </Col>
          </Row>
        </Container>  
      </form>
      {loading && <Loading />}
    </section>  
  )
}

export default SendSpecificMessage;